import { useCategoryPagePaginationData } from "@faire/deprecated-retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/DataFetching/useCategoryPagePaginationData";
import { CategoryPageRequestParamsProvider } from "@faire/deprecated-retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/CategoryPageRequestParamsProvider";
import { CategoryPagePrefetcher } from "@faire/deprecated-retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/CategoryPagePrefetcher";
import { useOneIndexedPageNumber } from "@faire/deprecated-retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/useOneIndexedPageNumber";
import { debounceIfPossible } from "@faire/web/common/globals/debounceIfPossible";
import { useRefFrom } from "@faire/web/common/hooks/useRefFrom";
import { WhenVisibilityIsImminent } from "@faire/web/ui/VisibilitySensor/WhenVisibilityIsImminent";
import React, { startTransition, useEffect } from "react";
import { useLocation } from "react-router-dom";

export const CategoryNextPagePrefetch: React.FC = () => {
  const paginationData = useCategoryPagePaginationData();
  const oneIndexedPageNumber = useOneIndexedPageNumber();
  const { pathname, search } = useLocation();
  const currentPath = `${pathname}${search}`;
  const [prefetchPagePath, setPrefetchPagePath] = React.useState(currentPath);
  // give time for page to scroll to top after page change
  const debouncedSetPrefetchPagePath = useRefFrom(() =>
    debounceIfPossible((path: string) => {
      startTransition(() => {
        setPrefetchPagePath(path);
      });
    }, 1000)
  ).current;

  useEffect(() => {
    if (prefetchPagePath !== currentPath) {
      debouncedSetPrefetchPagePath(currentPath);
    }
  }, [prefetchPagePath, currentPath, debouncedSetPrefetchPagePath]);

  const nextPageNumber = oneIndexedPageNumber + 1;
  const isNextPageAvailable =
    nextPageNumber <= (paginationData?.page_count ?? 0) && nextPageNumber > 0;

  // prefetchPagePath !== currentPath check is used to
  // rerender WhenVisibilityIsImminent to trigger the visibility sensor again
  if (!isNextPageAvailable || prefetchPagePath !== currentPath) {
    return null;
  }

  return (
    <WhenVisibilityIsImminent useTransition threshold={0}>
      <CategoryPageRequestParamsProvider pageNumber={nextPageNumber}>
        <CategoryPagePrefetcher />
      </CategoryPageRequestParamsProvider>
    </WhenVisibilityIsImminent>
  );
};
